import { render } from "./DeletedDoctors.vue?vue&type=template&id=74ef4141&scoped=true"
import script from "./DeletedDoctors.vue?vue&type=script&lang=js"
export * from "./DeletedDoctors.vue?vue&type=script&lang=js"

import "./DeletedDoctors.vue?vue&type=style&index=0&id=74ef4141&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ef4141"]])

export default __exports__